import { DownOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';
import React, { useState } from 'react';

const HeaderActionsDropdown = ({ items, label = 'Actions' }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dropdown
      menu={{ items, onClick: () => setIsOpen(false) }}
      trigger={['click']}
      placement="bottomRight"
      overlayClassName="header-actions-dropdown"
      open={isOpen}
      onOpenChange={setIsOpen}
    >
      <Button
        className={`header-actions-dropdown-btn ${isOpen ? 'is-open' : ''}`}
        size="middle"
      >
        {label}
        <DownOutlined className="header-actions-chevron" />
      </Button>
    </Dropdown>
  );
};

export default HeaderActionsDropdown;
